module.exports = __webpack_public_path__ + "static/media/logo-mini.fc9f8942.svg";